import type { SupportPort, SupportRequestView } from './ports.ts';
import type { WorkerClient } from './worker.ts';

// Owners read a projection; direct staff inbox documents contain private notes.
export function createSupport(worker: WorkerClient): SupportPort {
  return {
    history: limit => worker.call('get_my_support_history', { ...(limit === undefined ? {} : { limit }) }),
    get: async (queue, itemId) => (await worker.call<{ item: SupportRequestView }>('get_my_support_request', { queue, itemId })).item,
    create: input => worker.call('create_support_ticket', { pagePath: '/help', ...input, v2: true }),
    reply: input => worker.call('reply_support_ticket', input),
    messages: ticketId => worker.call('get_support_messages', { ticketId }),
  };
}
